<template>
    <div class="phase-wheels"></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import sdgWheels from './../../../js/sdg-wheel/sdg-wheels'

export default {
  name: 'phase-wheel',
  props: {
    multiple: {
      type: Boolean,
      required: false
    },
    selectAll: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
      activePhaseIndex: 'getActivePhaseIndex',
      activePhaseIndexes: 'getActivePhaseIndexes'
    })
  },
  methods: {
    ...mapActions({
      setActivePhaseIndex: 'setActivePhaseIndex',
      setActivePhaseIndexes: 'setActivePhaseIndexes'
    })
  },
  mounted () {
    let options = {
      // ændres til mode
      select: this.multiple ? 'multi' : 'select',
      phases: this.profile.phases.map(phase => {
        return {
          code: phase.code,
          name: phase.name,
          selected: phase.code === this.profile.phases[this.activePhaseIndex].code
        }
      })
    }

    this.phaseWheel = new sdgWheels.Phase(options)

    this.phaseWheel.on('select', (phase) => {
      if (!this.multiple) {
        this.setActivePhaseIndex(phase.phase)
      } else {
        this.setActivePhaseIndexes(this.phaseWheel.getSelected())
      }
    })

    this.phaseWheel.on('unselect', (phase) => {
      if (this.multiple) {
        this.setActivePhaseIndexes(this.phaseWheel.getSelected())
      }
    })

    this.$el.appendChild(this.phaseWheel.getSvg())

    if (this.selectAll) {
      this.phaseWheel.selectPhase(1)
      this.phaseWheel.selectPhase(2)
      this.phaseWheel.selectPhase(3)
      this.phaseWheel.selectPhase(4)
    }
  }
}
</script>
